// src/redux/actions/webappLayoutAction.ts
import { createAction } from "@reduxjs/toolkit";

export const setHeaderHeight = createAction<number | undefined>("webappLayout/setHeaderHeight");
